import { render, staticRenderFns } from "./ordnerruecken.vue?vue&type=template&id=4f469ece&"
import script from "./ordnerruecken.vue?vue&type=script&lang=js&"
export * from "./ordnerruecken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports